module.exports = __webpack_public_path__ + "static/media/logo_etu.29cd0641.webp";